import { Link, Login } from '@carbon/icons-react';
import { Tooltip } from '@routable/gross-ds';
import React from 'react';
const QuickswitchMembershipListIcon = ({ isReauthenticationRequired }) => {
    const Icon = isReauthenticationRequired ? Login : Link;
    return (React.createElement(Tooltip, { "data-testid": "quickswitch-membership--tooltip", tooltip: isReauthenticationRequired ? 'Reauthentication is required for this account.' : null, variant: "light" },
        React.createElement(Icon, { className: isReauthenticationRequired ? 'text-grey-60' : 'text-blue-40', "data-testid": isReauthenticationRequired ? 'icon--login' : 'icon--link', size: 14 })));
};
export default QuickswitchMembershipListIcon;
